import { Breakpoint } from '../themes/breakpoints'
import breakpoints from '../themes/breakpoints'
import { useDocumentSize, useMediaQuery } from '@jotta/hooks'
import { useMemo } from 'react'

const first = breakpoints[0]
const breakpointsReversed = breakpoints.toReversed()

export function useBreakpoint(): Breakpoint {
  const documentSize = useDocumentSize().current
  return useMemo(() => {
    // For browsers
    if (window && window.matchMedia) {
      return (
        breakpointsReversed.find(
          bp => window.matchMedia(`screen and (min-width: ${bp}px)`).matches,
        ) || first
      )
    }
    // For jest jsdom that doesn't understand window.matchMedia
    return (
      breakpointsReversed.find(br => {
        return br >= window.innerWidth
      }) || first
    )
  }, [documentSize])
}

export function useMobileBreakpoint() {
  // Find the pixel value for Breakpoint.xl
  const xlBreakpoint = Breakpoint.xl
  // Mobile is below xl, so use max-width: xl-1
  const isMobile = useMediaQuery(`(max-width: ${xlBreakpoint - 1}px)`)
  return isMobile
}
